import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import TopBar from "@/components/TopBar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const wrap = { hidden: {}, show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } } };
const line = { hidden: { y: "112%" }, show: { y: "0%", transition: { duration: 0.7, ease: [0.22, 0.61, 0.36, 1] } } };
const fade = { hidden: { opacity: 0, y: 18 }, show: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.45 } } };

export default function Adritools() {
  const [idea, setIdea] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [estado, setEstado] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    document.title = "Adritools · Creatividad²";
  }, []);

  async function enviarIdea(e) {
    e.preventDefault();
    if (!idea.trim()) {
      setErrorMsg("Cuéntame la idea primero: ¿qué herramienta te haría la vida más fácil?");
      setEstado("error");
      document.getElementById("idea-input")?.focus();
      return;
    }
    setEstado("sending");
    setErrorMsg("");
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 12000);
    try {
      const resp = await fetch(`${API}/ideas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        signal: ctrl.signal,
        body: JSON.stringify({ idea, email, website, pagina: window.location.href }),
      });
      clearTimeout(t);
      const json = await resp.json().catch(() => ({}));
      if (!resp.ok || json.ok === false) throw new Error("fallo");
      setEstado("exito");
    } catch {
      clearTimeout(t);
      setEstado("error");
      setErrorMsg("No se pudo enviar. Tu idea sigue aquí: inténtalo de nuevo.");
    }
  }

  return (
    <div>
      <TopBar />
      <section className="step adritools" data-testid="adritools-menu">
        <div className="step-inner" style={{ maxWidth: 900 }}>
          <motion.div variants={wrap} initial="hidden" animate="show">
            <motion.p className="eyebrow" variants={fade}>
              <span className="mk-estrella" aria-hidden="true" /> Adriana V. Márquez
            </motion.p>
            <h1 className="hero-title display" data-testid="adritools-title">
              <span className="lr"><motion.span className="lr-in" variants={line}>Adri<span className="marcador">tools</span>.</motion.span></span>
            </h1>
            <motion.p className="hero-sub" variants={fade}>
              Herramientas gratis para creadores, entrepreneurs y marcas. Con números, no con
              corazonadas.
            </motion.p>
            <motion.div className="tools-list" variants={fade}>
              <Link to="/calcula-tu-rate" className="tool-card" data-testid="tool-card-calculadora">
                <span className="tool-num">Tool 01</span>
                <span className="tool-name display">Calculadora de Tarifas</span>
                <span className="tool-desc">
                  Tu piso por crear y postear un video, con tus números reales: seguidores,
                  engagement y lo que tu audiencia vale para una marca.
                </span>
                <span className="tool-cta" data-testid="tool-cta-calculadora">
                  Abrir <span className="mk-estrella" aria-hidden="true" />
                </span>
              </Link>
              <a href="/prompts" className="tool-card" data-testid="tool-card-prompts">
                <span className="tool-num">Tool 02</span>
                <span className="tool-name display">Prompts de IA para empezar de cero</span>
                <span className="tool-desc">
                  Dieciséis prompts para copiar y pegar, organizados por lo que necesitas
                  resolver, no por la herramienta.
                </span>
                <span className="tool-cta" data-testid="tool-cta-prompts">
                  Abrir <span className="mk-estrella" aria-hidden="true" />
                </span>
              </a>
              <div className="tool-card tool-prox" data-testid="tool-card-proxima">
                <span className="tool-num">Tool 03 · Próximamente</span>
                <span className="tool-name display">¿Qué tool te falta?</span>
                {estado === "exito" ? (
                  <div className="exito" aria-live="polite" data-testid="idea-exito">
                    <strong>¡Anotada! Gracias.</strong>
                    Si la construyo, te aviso por correo.
                  </div>
                ) : (
                  <form className="idea-form" onSubmit={enviarIdea} noValidate data-testid="idea-form">
                    <textarea
                      id="idea-input"
                      data-testid="idea-input"
                      className="campo-input idea-textarea"
                      placeholder="Cuéntame la herramienta que te haría la vida más fácil…"
                      value={idea}
                      onChange={(e) => setIdea(e.target.value)}
                      aria-label="Tu idea de herramienta"
                    />
                    <input
                      id="idea-email-input"
                      data-testid="idea-email-input"
                      className="campo-input"
                      type="email"
                      name="email"
                      autoComplete="email"
                      inputMode="email"
                      spellCheck="false"
                      placeholder="Tu correo si quieres que te avise (opcional)"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      aria-label="Tu correo (opcional)"
                    />
                    <div className="honeypot" aria-hidden="true">
                      <label htmlFor="idea-website">Website</label>
                      <input
                        id="idea-website"
                        type="text"
                        name="website"
                        tabIndex={-1}
                        autoComplete="off"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                      />
                    </div>
                    {errorMsg && (
                      <p className="error" role="alert" data-testid="idea-error">
                        {errorMsg}
                      </p>
                    )}
                    <div className="form-actions">
                      <button
                        type="submit"
                        className="btn btn-cta btn-sm"
                        disabled={estado === "sending"}
                        data-testid="idea-submit"
                      >
                        {estado === "sending" ? "Enviando…" : estado === "error" ? "Reintentar" : "Enviar idea"}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
